import parse from 'html-react-parser'

export const getNodeCell = ({node, isParagraph = false, isFont = {}}) => {
  const typeOfFontStyling = {
    b: {bold: true},
    strong: {bold: true},
    i: {italic: true},
    em: {italic: true},
    u: {underline: true},
  }

  // base condition
  if (typeof node === 'string') {
    return {text: isParagraph ? `${node}\n` : node, font: {...isFont}}
  }

  if (node.type === 'br') {
    // Handle line breaks
    return {text: '\n'}
  }

  let children = node.props.children
  if (typeOfFontStyling[node.type]) {
    // to check if theres other child inside
    if (Array.isArray(children)) {
      return node.props.children
        .map((child, index) => {
          // Recursively process nested child nodes
          return getNodeCell({node: child, isFont: typeOfFontStyling[node.type]})
        })
        .flat()
    } else if (typeof children === 'string') {
      return {
        text: isParagraph ? `${children}\n` : children,
        font: {...isFont, ...typeOfFontStyling[node.type]},
      }
    } else if (typeof children === 'object') {
      //to go deeper
      if (Array.isArray(children?.props?.children)) {
        return children?.props?.children.map((child, index) => {
          let nested = getNodeCell({
            node: child,
            isFont: typeOfFontStyling[children?.type],
          })

          return {
            text: isParagraph ? `${nested.text}\n` : nested.text,
            font: {...nested.font, ...isFont},
          }
        })
      } else {
        let nested = getNodeCell({
          node: children,
          isFont: typeOfFontStyling[node.type],
        })

        return {
          text: isParagraph ? `${nested.text}\n` : nested.text,
          font: {...nested.font, ...isFont},
        }
      }
    }
  } else if (node.type === 'p' || node.type === 'span') {
    if (node.props.children === null) {
      // Handle line breaks
      return {text: '\n', font: {...isFont}}
    } else if (Array.isArray(children)) {
      return (
        children
          .map((child, index) => {
            const styledChild = getNodeCell({
              node: child,
              isParagraph: index === children.length - 1,
              isFont: {...isFont, ...typeOfFontStyling[child.type]},
            })

            if (
              !styledChild ||
              (Array.isArray(styledChild) && styledChild.length === 0)
            ) {
              return {
                text: '',
                font: {...typeOfFontStyling[child.type], ...isFont},
              }
            }
            // Recursively process nested child nodes
            return styledChild
          })
          //for nested arrays
          .flat()
      )
    }

    return getNodeCell({node: children, isParagraph: true})
  }
}

export const getStyledCellValue = (cellValue) => {
  let richText = []
  let plainText = cellValue

  // If the cell value contains HTML, parse it to extract rich text
  if (typeof cellValue === 'string' && /<\/?[a-z][\s\S]*>/i.test(cellValue)) {
    const parsedHtml = parse(cellValue, {trim: true})

    // Check if parsedHtml is an array or a single node
    const nodes = Array.isArray(parsedHtml) ? parsedHtml : [parsedHtml]
    // Process the parsed HTML to extract rich text and styles
    nodes.forEach((node, index) => {
      const result = getNodeCell({node, isParagraph: node.type === 'p'})
      if (Array.isArray(result)) {
        richText = [...richText, ...result]
      } else {
        let formattedResult = result ?? {
          text: '',
        }
        richText.push(formattedResult)
      }
    })
    // Create plainText from richText (remove formatting)
    plainText = richText.map((item) => item?.text).join('')
  }

  return {plainText, richText}
}
